import React from 'react';
import styled from 'styled-components'
import closeIcon from '../images/Close-button@2x.png'
import backIcon from '../images/Back-button.png'

const Wrapper = styled.div`
    display: flex;
    justify-content: ${(props) => props.clickBack ? 'space-between' : 'flex-end'};
    margin-bottom: 16px;
`
const Img = styled.img`
    width: 24px;
    height: 24px;
`;

const BackClose = ({ clickBack, previousState, clickClose }) => (
    <Wrapper clickBack={clickBack}>
        {clickBack && <Img onClick={() => clickBack(previousState)} src={backIcon} alt="back" />}
        <Img onClick={() => clickClose(false)} src={closeIcon} alt="close" />
    </Wrapper>
)

export default BackClose
